export class RadioGroupItem {
    constructor(
        public Item: boolean,
        public Watermark: string,    
        public IsDisabled: boolean
    ) { }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/objects/request/radio-group/radio-group-item.ts